export const appointmentRoutes = {
  'api.appointment.service-fee': 'appointments/user-service-fee',
  'api.appointment.service-date': 'appointments/show',
  'api.appointment.service-timesheet': 'appointments/timesheet',
  'api.appointment.service-store': 'appointments',
};
